<template>
  <div class="animated fadeIn">
    <b-card>
      <b-row class="mb-2">
        <b-col>
          <h2>ส่งอีเมล</h2>
        </b-col>
        <b-col>
          <b-button variant="primary" @click="sendEmail" class="float-right">ส่งอีเมล</b-button>
        </b-col>
      </b-row>
      <b-row class="mt-2">
        <b-col>
          <label for="to">ส่งเมลรายคน (คั่นด้วย , )</label>
          <b-form-input v-model="to" placeholder="รายชื่อเมล" :disabled="toDisable"></b-form-input>
          <b-form-checkbox id="toAll" v-model="toAll" name="toAll">ส่งเมลหาทุกคนในระบบ</b-form-checkbox>
        </b-col>
      </b-row>
      <b-row class="mt-2">
        <b-col>
          <label for="emailTitle">หัวเรื่อง</label>
          <b-form-input v-model="emailTitle" placeholder="email title"></b-form-input>
        </b-col>
      </b-row>
      <b-row class="mt-2">
        <b-col>
          <div class="email">
            <quill-editor
              ref="myQuillEditor"
              class="editor"
              v-model="content"
              :options="editorOption"
              @blur="onEditorBlur($event)"
              @focus="onEditorFocus($event)"
              @ready="onEditorReady($event)"
            />
          </div>
        </b-col>
      </b-row>
    </b-card>
    <ModalLoading />
  </div>
</template>

<script>

import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

import { quillEditor } from 'vue-quill-editor'

import Email from '../../../services/http/Email'

import ModalLoading from '../../../components/ModalLoading'

export default {
  components: {
    quillEditor,
    ModalLoading
  },
  name: 'app',
  data () {
    return {
      emailTitle: null,
      content: '',
      editorOption: {
        // The configuration of the editor.
        placeholder: 'email content',
        theme: 'snow'
      },
      toAll: false,
      to: null
    }
  },
  methods: {
    onEditorBlur (quill) {
      // console.log('editor blur!', quill)
    },
    onEditorFocus (quill) {
      // console.log('editor focus!', quill)
    },
    onEditorReady (quill) {
      // console.log('editor ready!', quill)
    },
    onEditorChange ({ quill, html, text }) {
      // console.log('editor change!', quill, html, text)
      this.content = html
    },
    async sendEmail () {
      // console.log(this.content)
      Window.Event.$emit('showModalLoading')
      let data = {
        emailContent: this.content,
        emailTitle: this.emailTitle
      }
      if (this.toAll) {
        data['toAll'] = this.toAll
      } else if (this.to) {
        data['to'] = this.to
      } else {
        alert('โปรดติดต่อผู้ดูแลระบบ')
        Window.Event.$emit('closeModalLoading')
        return
      }

      try {
        let email = new Email()
        let result = await email.sendEmail(data)
        if (result.code === 1) {
          alert('ส่งเมลสำเร็จ')
        } else {
          alert(result.error)
        }
      } catch (error) {
        console.log(error)
        alert('โปรดติดต่อผู้ดูแลระบบ')
        Window.Event.$emit('closeModalLoading')
      }
      Window.Event.$emit('closeModalLoading')
    }
  },
  computed: {
    editor () {
      return this.$refs.myQuillEditor.quill
    },
    toDisable () {
      if (this.toAll) {
        return true
      } else {
        return false
      }
    }
  },
  mounted () {
    console.log('this is current quill instance object', this.editor)
  }
}
</script>
